<footer class="footer-area" style="padding: 0;">
  <div class="container">
        <div class="col-md-6 mb-2">
          <img src="/assets/logo-latam.png" alt="Logo">
      </div>
  </div>
</footer>